import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import SparkleIcon from "Components/common/SparkleIcon";
import copilotStore from "Stores/copilotStore";
import { applyAgentPageEdit } from "Pages/Dashboard/agents/agentPageCopilot";

// Applied once per block per page load, and only while its turn is live: reopening an old chat
// must not re-apply a change to whatever agent form happens to be open (same rule as PageFiltersBlock).
const applied = new Set();

/** Copilot changed the agent form/builder beside the chat; apply it there and say what changed. */
const AgentPageEditBlock = observer(({ block }) => {
  const [state, setState] = useState("idle"); // idle | applying | done | error | skipped
  const [result, setResult] = useState(null);

  useEffect(() => {
    if (applied.has(block.id)) return;
    applied.add(block.id);
    if (!copilotStore.streaming) {
      setState("skipped");
      return;
    }
    setState("applying");
    applyAgentPageEdit(block).then(r => {
      setResult(r);
      setState(r && r.error ? "error" : "done");
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [block.id]);

  if (state === "skipped") {
    return (
      <div className="copilotPageFilters copilotPageFilters--skipped">
        <SparkleIcon />
        <span>Changes were applied on the agent page.</span>
      </div>
    );
  }
  const changed = (result && result.changed) || [];
  return (
    <div className={`copilotPageFilters${state === "error" ? " copilotPageFilters--skipped" : ""}`}>
      <div className="copilotPageFilters__head">
        <SparkleIcon />
        <span className="copilotPageFilters__title">
          {state === "applying" || state === "idle"
            ? "Updating the agent on the left…"
            : state === "error"
              ? result.error
              : "Updated on the left. Review it, then create or save."}
        </span>
      </div>
      {state === "done" && changed.length > 0 && (
        <div className="copilotPageFilters__chips">
          {changed.map(c => (
            <span className="copilotPageFilters__chip" key={c}>{c}</span>
          ))}
        </div>
      )}
    </div>
  );
});

export default AgentPageEditBlock;
